import { useEffect, useState } from "react";
import { useLang } from "../context/LanguageContext";
import { api } from "../context/AuthContext";
import { Home, Users, Star, Percent } from "lucide-react";

const fmt = (n) =>
  new Intl.NumberFormat("pt-PT", { maximumFractionDigits: 0 }).format(n || 0);

const Stat = ({ icon: Icon, value, label }) => (
  <div className="flex flex-col items-center text-center px-4 py-6">
    <Icon size={22} strokeWidth={1.3} className="text-[#C5A059]" />
    <div className="font-serif-display text-4xl md:text-5xl font-light text-[#F4F1EB] mt-3 leading-none">
      {value}
    </div>
    <div className="overline mt-2 text-[10px]">{label}</div>
  </div>
);

const StatsStrip = () => {
  const { t } = useLang();
  const [stats, setStats] = useState(null);

  useEffect(() => {
    api.get("/public/stats").then(({ data }) => setStats(data)).catch(() => {});
  }, []);

  if (!stats || !stats.houses) return null;

  return (
    <section className="bg-[#0A1128] text-[#F4F1EB] relative overflow-hidden" data-testid="stats-strip">
      {/* subtle gold accents */}
      <div
        className="absolute inset-0 opacity-[0.06] pointer-events-none"
        style={{
          backgroundImage:
            "radial-gradient(circle at 10% 30%, #C5A059 0px, transparent 360px), radial-gradient(circle at 90% 70%, #C5A059 0px, transparent 320px)",
        }}
      />
      <div className="relative max-w-7xl mx-auto px-6 md:px-12 py-12 md:py-16">
        <div className="text-center mb-8">
          <div className="overline text-[#C5A059]">{t.stats.overline}</div>
          <h2 className="font-serif-display text-2xl md:text-4xl font-light text-[#F4F1EB] mt-2">
            {t.stats.title}
          </h2>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 divide-x divide-[#F4F1EB]/10 border border-[#F4F1EB]/10">
          <Stat icon={Home} value={fmt(stats.houses)} label={t.stats.houses} />
          <Stat icon={Users} value={fmt(stats.guests)} label={t.stats.guests} />
          <Stat
            icon={Star}
            value={stats.avg_rating > 0 ? stats.avg_rating.toFixed(2) : "—"}
            label={t.stats.rating}
          />
          <Stat
            icon={Percent}
            value={stats.avg_occupancy > 0 ? `${stats.avg_occupancy}%` : "—"}
            label={t.stats.occupancy}
          />
        </div>
      </div>
    </section>
  );
};

export default StatsStrip;
